// import external from "@/gavnoCode/external";
// import errorHandlerExternal from "@/plugins/errorHandlerExternal";
// import router from "@/router";


const state = {
  selectedScan: {},
  navScan: {},
  dealData: [],
  step2Scans: [],
  imgSRC: '',
  imgArray: [],
  step2End: false,
};

const getters = {
};

const actions = {
  setCurrentScan: ({commit, dispatch}, scanStepName) => {
    // console.log('выбор скана, как текущего');
    // console.log('входящий stepName скана: ' + scanStepName);
    // console.log('полный массив объектов описания сканов который у нас есть: ');
    // console.log(state.dealData.ref_scan_list);
    // console.log('ищем нужный по массиву dealData.ref_scan_list');
    let found = state.dealData.ref_scan_list.findIndex((item) => {
      return item.stepName === scanStepName;
    })
    // console.log('индекс: ' + found);
    if (found >= 0) {
      // console.log('найденный элемент: ');
      // console.log(state.dealData.ref_scan_list[found]);
      // console.log('сохраняем скан как текущий')
      commit('setSavedScan', state.dealData.ref_scan_list[found]);
      commit('setColdNavScan', state.dealData.ref_scan_list[found]);
      dispatch('preparePhoto');
    }
  },
  step2goToNextScan: ({commit, dispatch}) => {
    // console.log('Нажали кнопку "ДАЛЕЕ": ');
    // console.log('ищем индекс прошлого скана ' + state.selectedScan.stepName + ' в state.step2Scans');
    // console.log('state.step2Scans: ');
    // console.log(state.step2Scans);
    let found = state.step2Scans.findIndex((item) => {
      return item.stepName === state.selectedScan.stepName;
    });
    // console.log('Элемент найден под индексом ' + found);
    // console.log('Индекс последнего элемента step2Scans: ' + (state.step2Scans.length -1));
    if (found >= 0 && found < state.step2Scans.length - 1) {
      // console.log('Следующий скан : ' + (state.step2Scans[found + 1].stepName));
      commit('setSavedScan', state.step2Scans[found + 1]);
      commit('setSavedNavScan', state.step2Scans[found + 1]);
      dispatch('preparePhoto');
    }
    if (found + 1 === state.step2Scans.length - 1) {
      // console.log('сканы кончились')
      commit('setEndOfStep2');
    }
  },
  showSelectedScanImage: ({commit}) => {
    let foundIndex = state.imgArray.findIndex((item) => {
      return item.shortName === state.navScan.nameBD;
    });
    if (foundIndex >= 0) {
      commit('setImgSRC', 'data:image/jpeg;base64,' + state.imgArray[foundIndex].fileData);
    }
  },
  saveDealData: ({commit}, dealData) => {
    // console.log('сохраняем данные по заявке в хранилище');
    // console.log('отдельно отфильтровываем объект сканов для второго шага');
    const filteredData = dealData.ref_scan_list.filter(
        item => item.nameRu !== 'Паспорт_1'
            && item.nameRu !== 'Заявление на усл'
    );
    commit('setDemandData', dealData);
    commit('setStep2Scans', filteredData);
  },
  preparePhoto: ({commit}) => {
    let foundIndex = state.imgArray.findIndex(element=>element.shortName === state.selectedScan.nameBD);
    if (state.imgArray[foundIndex]) {
      commit('setImgSRC', 'data:image/jpeg;base64,' + state.imgArray[foundIndex].fileData);
    } else {
      commit('setImgSRC', '');
    }
  },
};

const mutations = {
  setSavedScan:(state, selectedScan) => { state.selectedScan = selectedScan },
  setSavedNavScan:(state, selectedScan) => { state.navScan = selectedScan },
  setColdNavScan:(state, neededScan) => { state.navScan = neededScan},
  setDemandData:(state, data) => { state.dealData = data },
  setStep2Scans:(state, data) => { state.step2Scans = data },
  setEndOfStep2:(state) => { state.step2End = true },
  setImgSRC:(state, imgString) => { state.imgSRC = imgString },
  pushPhotoInArray:(state, elem) => { state.imgArray.push(elem) },
  RESET_STATE: (state) => {
    const initialState = {
      selectedScan: {},
      navScan: {},
      dealData: [],
      step2Scans: [],
      imgSRC: '',
      imgArray: [],
      step2End: false,
    };

    // Копируем значения, чтобы не потерять ссылку на сам объект state
    Object.assign(state, initialState);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
